'use strict';

purchasingRequisitionsController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$uibModal',
	'dialogHelper',
	'$filter',
	'$interval',
	'reportHelper',
	'utilsService',
	'purchaseOrderSetupService',
	'purchaseOrderService',
	'purchaseAddEditHelper',
	'authService',
	'USER_CLAIMS',
	'PO_STATUS',
	'PURCHASING_TYPES',
	'BUSY_MESSAGE',
	'ROLE_CLAIMS',
];
angular.module('schoolLinqApp').controller('purchasingRequisitionsController', purchasingRequisitionsController);

function purchasingRequisitionsController(
	$scope,
	$rootScope,
	$q,
	$uibModal,
	dialogHelper,
	$filter,
	$interval,
	reportHelper,
	utilsService,
	purchaseOrderSetupService,
	purchaseOrderService,
	purchaseAddEditHelper,
	authService,
	USER_CLAIMS,
	PO_STATUS,
	PURCHASING_TYPES,
	BUSY_MESSAGE,
	ROLE_CLAIMS
) {
	$scope.vm = getViewModel($rootScope.mode || 'fund');
	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.busyPromise = $q
		.all([$scope.vm.getApprovalUsers(), $scope.vm.loadSitePOSetup($scope.vm), $scope.vm.loadPurchaseOrderStatus($scope.vm)])
		.then(function () {
			$scope.busyPromise = $scope.vm.loadRequisitions($scope.vm);
		});

	function getViewModel(moduleName) {
		const lsb = 'lsb';
		var fieldClaims = authService.authentication.fieldClaims;
		var docMgmtPermission = null; // authService.hasPageClaim(payableClaims, 'ManageRequisitionsDocMgmt', USER_CLAIMS.fund, 'purchasing');

		var model = {
			module: moduleName,
			requisitions: [],
			totalRequisitions: 0,
			canApprove: false,
			liveFilters: {
				search: '',
				type: 'Site',
				statusId: PO_STATUS.Open,
				poFrom: null,
				poTo: null,
				fromDT: moment(new Date().setMonth(new Date().getMonth() - 2)).toDate(),
				toDT: new Date(),
			},
			filter: {
				search: '',
				purchasingType: PURCHASING_TYPES.Requisition,
				purchasingTypeDesc: 'Requisition',
				type: 'Site',
				statusId: PO_STATUS.Open,
				propertyName: 'ReqNumber',
				poFrom: null,
				poTo: null,
				fromDT: moment(new Date().setMonth(new Date().getMonth() - 2)).toDate(),
				toDT: new Date(),
				reverse: false,
				pageSize: 12,
				startIndex: 0,
			},
			pageControl: {},
			typeaheadLimit: 10,
			numberOfPages: [],
			sitePOSetup: {
				Id: null,
			},
			newEditState: null,
			busyMessage: BUSY_MESSAGE.Loading,
			errors: null,
			siteAccounting: authService.authentication.siteAccounting,
			canPrintPOs: authService.isAccessible(USER_CLAIMS.lsb, 'purchasing', 'PrintSendPOs'),
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'ManageRequisitions', 'purchasing'),
			docMgmt: {
				permissionLevel: docMgmtPermission,
				hasConfidentialAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementManageRequisitionsDocMgmtConfidential,
				}),
				hasDeleteAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementManageRequisitionsDocMgmtDelete,
				}),
			},
		};

		function loadRequisitions(model) {
			if (model.filter.fromDT) {
				model.filter.fromDT.setHours(0, 0, 0, 0);
			}
			if (model.filter.toDT) {
				model.filter.toDT.setHours(0, 0, 0, 0);
			}
			return purchaseOrderService.searchPurchaseOrders(model.filter).then(_.partial(finishLoadingRequisitions, model));

			function finishLoadingRequisitions(model, response) {
				model.requisitions = response.data.PurchaseOrders;
				model.totalRequisitions = response.data.Total;

				angular.forEach(model.requisitions, function (po) {
					if (po.ShowOverBudgetWarnings) {
						angular.forEach(po.PurchaseOrderAccounts, function (poa) {
							if (((model.sitePOSetup && model.sitePOSetup.PercentOverBudgetAllowed) || 0) > 0) {
								const calculatedBuffer = emsRound(
									(poa.RemainingBudget + poa.Total) * (parseFloat(model.sitePOSetup.PercentOverBudgetAllowed) / 100)
								);
								poa.budgetExceeded = calculatedBuffer + poa.RemainingBudget < 0;
							} else {
								poa.budgetExceeded = poa.RemainingBudget < 0;
							}
						});
						po.AnyOverBudgetAccounts = _.any(po.PurchaseOrderAccounts, function (poa) {
							return poa.budgetExceeded === true;
						});
					} else {
						po.AnyOverBudgetAccounts = false;
					}
				});

				return angular.noop;
			}
		}

		function changePage(model) {
			model.filter.startIndex = model.pageControl.startIndex;
			model.busyMessage = BUSY_MESSAGE.Loading;
			$scope.busyPromise = model.loadRequisitions(model);
		}

		function newEditRequisition(model, id) {
			$scope.vm.newEditState = 'start';

			if (!id) {
				// check if SitePOSetup record exists if not siteAccounting.

				if ($scope.vm.siteAccounting !== true && parseInt($scope.vm.sitePOSetup.Id) === 0) {
					const message = 'Purchase Order Setup is missing!';
					const messageDetail = 'Please navigate to "SYSTEM SETTINGS >> SYSTEM SETUP >> Purchase Order Setup" to resolve this issue.';
					dialogHelper.openMessageBox(message, messageDetail, null, 'Warning');

					return angular.noop;
				}
			}

			const funcCallBack = function (added) {
				$scope.vm.newEditState = 'Done';
				if (added) {
					model.busyMessage = BUSY_MESSAGE.Loading;
					$scope.busyPromise = model.loadRequisitions();
				}
			};

			return purchaseAddEditHelper.openAddEditDialog(model.module, id, PURCHASING_TYPES.Requisition, funcCallBack);
		}

		function loadSitePOSetup(model) {
			if (model.siteAccounting !== true) {
				return purchaseOrderSetupService.getBySiteId(null).toPromise().then(_.partial(finishGetPOSetup, model));
			}

			function finishGetPOSetup(model, response) {
				model.sitePOSetup = response;
				return angular.noop;
			}
		}

		function loadPurchaseOrderStatus(model) {
			return utilsService.getPurchaseOrderStatuses().then(_.partial(finishLoadingPurchaseOrderStatuses, model));

			function finishLoadingPurchaseOrderStatuses(model, response) {
				model.purchaseOrderStatus = _.filter(response.data.purchaseOrderStatus, function (status) {
					return status.Id !== 3;
				});
				model.purchaseOrderStatus.unshift({ Id: [1, 2], Description: 'All' });
				return angular.noop;
			}
		}

		function applyFilter(model, requisition) {
			if (model.filter.search || (model.filter.poFrom && model.filter.poTo)) {
				switch (model.filter.type) {
					case 'Site':
						return requisition.ShipTo.toLowerCase().indexOf(model.filter.search.toLowerCase()) !== -1;
					case 'Vendor':
						return requisition.OrderTo.toLowerCase().indexOf(model.filter.search.toLowerCase()) !== -1;
					case 'Req Number':
						return requisition.ReqNumber >= model.filter.poFrom && requisition.ReqNumber <= model.filter.poTo;
				}
			}
			return true;
		}

		function searchTextChanged(model) {
			$scope.reqSearchForm.$setDirty();
		}

		function search(model) {
			model.busyMessage = BUSY_MESSAGE.Loading;
			model.filter.search = model.liveFilters.search;
			model.filter.type = model.liveFilters.type;
			model.filter.statusId = model.liveFilters.statusId;
			model.filter.poFrom = model.liveFilters.poFrom;
			model.filter.poTo = model.liveFilters.poTo;
			model.filter.fromDT = model.liveFilters.fromDT;
			model.filter.toDT = model.liveFilters.toDT;

			if ($scope.reqSearchForm.$dirty) {
				model.filter.startIndex = 0;
				if (model.pageControl.currentPageIndex && model.pageControl.currentPageIndex !== 0) {
					model.pageControl.setPageIndexBack(0);
				}
				$scope.reqSearchForm.$setPristine();
			}

			$scope.busyPromise = model.loadRequisitions();
		}

		function selectAll(model) {
			var seenItems, i;
			if (model.isAllSelected()) {
				seenItems = $filter('filter')(model.requisitions, model.applyFilter);
				for (i = 0; i < seenItems.length; i++) {
					seenItems[i].Selected = false;
				}
			} else {
				seenItems = $filter('filter')(model.requisitions, model.applyFilter);
				for (i = 0; i < seenItems.length; i++) {
					if (seenItems[i].Status === 'Open') {
						seenItems[i].Selected = true;
					}
				}
			}
		}

		function isAllSelected(model) {
			var seenItems = $filter('filter')(model.requisitions, model.applyFilter);
			if (seenItems.length > 0) {
				for (var i = 0; i < seenItems.length; i++) {
					if (!seenItems[i].Selected && seenItems[i].Status === 'Open') {
						return false;
					}
				}
			} else {
				return false;
			}
			return true;
		}

		function selectedCount(model) {
			var seenItems = $filter('filter')(model.requisitions, model.applyFilter);
			var numberSelected = 0;
			for (var i = 0; i < seenItems.length; i++) {
				if (seenItems[i].Selected) {
					numberSelected++;
				}
			}
			return numberSelected;
		}

		function hasListItems(model) {
			return model.requisitions.length > 0;
		}

		function closeOrDeleteReqs(model) {
			var selectedPO = _.filter($filter('filter')(model.requisitions, model.applyFilter), function (po) {
				return po.Selected === true;
			});
			$uibModal
				.open({
					template: require('@ajs/templates/fund/purchasing/purchaseOrder-closemany-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'purchaseOrderService',
						function ($scope, modalInstance, purchaseOrderService) {
							$scope.purchasingTypeDesc = model.filter.purchasingTypeDesc;

							$scope.PODelete = _.filter(selectedPO, function (po) {
								return po.CanDelete;
							});
							$scope.POClose = _.filter(selectedPO, function (po) {
								return !po.CanDelete;
							});
							$scope.deletePOs = false;
							$scope.closePOs = false;

							if ($scope.PODelete.length === 1) {
								$scope.PODeleteMessage = 'Delete 1 Requisition.';
							} else {
								$scope.PODeleteMessage = 'Delete ' + $scope.PODelete.length + ' Requisitions.';
							}

							if ($scope.POClose.length === 1) {
								$scope.POCloseMessage = 'Close 1 Requisition.';
							} else {
								$scope.POCloseMessage = 'Close ' + $scope.POClose.length + ' Requisitions.';
							}

							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								execute: function () {
									if (!$scope.deletePOs && !$scope.closePOs) return;
									var promises = [];
									let busyMsg = 'Closing / Deleting ....';

									if ($scope.deletePOs) {
										if (!$scope.closePOs) busyMsg = 'Deleting ....';
										angular.forEach($scope.PODelete, function (PO) {
											promises.push(purchaseOrderService.deletePO(PO.Id));
										});
									}

									if ($scope.closePOs) {
										if (!$scope.deletePOs) busyMsg = 'Closing ....';
										angular.forEach($scope.POClose, function (PO) {
											promises.push(purchaseOrderService.closePO(PO.Id));
										});
									}

									model.busyMessage = busyMsg;
									$scope.busyPromise = $q.all(promises).then(finishClosingDeleting);

									function finishClosingDeleting(response) {
										$uibModal
											.open({
												template: require('@ajs/templates/fund/purchasing/purchaseOrder-closemany-complete-modal.html'),
												backdrop: 'static',
												keyboard: false,
												scope: $scope,
												controller: [
													'$scope',
													'$uibModalInstance',
													function ($scope, modalInstance) {
														$scope.totalClosedDeleted = _.filter(response, function (res) {
															return res.data.isValid;
														}).length;

														$scope.totalFailed = response.length - $scope.totalClosedDeleted;

														angular.extend($scope, {
															done: function () {
																modalInstance.close();
															},
														});
													},
												],
											})
											.result.then(function () {
												modalInstance.close();
											});
									}
								},
							});
						},
					],
				})
				.result.then(function () {
					model.busyMessage = BUSY_MESSAGE.Loading;
					$scope.busyPromise = model.loadRequisitions();
				});
		}

		function closeOrDeleteReq(model, po) {
			if (po.CanDelete) {
				$uibModal
					.open({
						template: require('@ajs/templates/fund/purchasing/purchaseOrder-delete-modal.html'),
						backdrop: 'static',
						keyboard: false,
						scope: $scope,
						controller: [
							'$scope',
							'$uibModalInstance',
							'purchaseOrderService',
							function ($scope, modalInstance, purchaseOrderService) {
								$scope.purchasingTypeDesc = model.filter.purchasingTypeDesc;

								angular.extend($scope, {
									cancel: function () {
										modalInstance.close();
									},
									deletePO: function () {
										$scope.deletingPromise = purchaseOrderService.deletePO(po.Id).then(function (response) {
											if (response.data.isValid) {
												modalInstance.close(true);
											} else {
												$scope.errors = response.data.errors;
											}
										});
									},
								});
							},
						],
					})
					.result.then(function (reload) {
						if (reload) {
							model.busyMessage = BUSY_MESSAGE.Loading;
							$scope.busyPromise = model.loadRequisitions();
						}
					});
			} else {
				$uibModal
					.open({
						template: require('@ajs/templates/fund/purchasing/purchaseOrder-close-modal.html'),
						backdrop: 'static',
						keyboard: false,
						scope: $scope,
						controller: [
							'$scope',
							'$uibModalInstance',
							'purchaseOrderService',
							function ($scope, modalInstance, purchaseOrderService) {
								$scope.purchasingTypeDesc = model.filter.purchasingTypeDesc;

								angular.extend($scope, {
									cancel: function () {
										modalInstance.close();
									},
									closePO: function () {
										$scope.closingPromise = purchaseOrderService.closePO(po.Id).then(function (response) {
											if (response.data.isValid) {
												modalInstance.close(true);
											} else {
												$scope.errors = response.data.errors;
											}
										});
									},
								});
							},
						],
					})
					.result.then(function (reload) {
						if (reload) {
							model.busyMessage = BUSY_MESSAGE.Loading;
							$scope.busyPromise = model.loadPurchaseOrders();
						}
					});
			}
		}

		function printReqList(model) {
			model.busyMessage = BUSY_MESSAGE.GeneratingReport;
			$scope.isReportFinished = false;
			$scope.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var poIds = [];
			var poItems = $filter('filter')(model.requisitions, model.applyFilter);
			poItems = $filter('orderBy')(poItems, model.filter.propertyName, model.filter.reverse);
			_.each(poItems, function (item) {
				poIds.push(item.Id);
			});
			// build filter text
			var filters = [];
			if ((model.filter.type === 'Site' || model.filter.type === 'Vendor') && model.filter.search.length > 0) {
				filters.push(model.filter.type + ": '" + model.filter.search + "'");
			}
			if (model.filter.type === 'Req Number' && model.filter.poFrom && model.filter.poTo) {
				filters.push('PO# from ' + model.filter.poFrom + ' to ' + model.filter.poTo);
			}
			if (model.filter.fromDT && model.filter.toDT) {
				filters.push(
					'Date from ' + moment(model.filter.fromDT).format('MM/DD/YYYY') + ' to ' + moment(model.filter.toDT).format('MM/DD/YYYY')
				);
			}
			if (Array.isArray(model.filter.statusId)) {
				filters.push('Req Status: All');
			} else {
				filters.push(
					'Req Status: ' +
						_.findWhere(model.purchaseOrderStatus, {
							Id: model.filter.statusId,
						}).Description
				);
			}
			var filterText = filters.join('; ');

			var report = {
				POIds: poIds,
				FilterText: filterText,
			};

			reportHelper.postReport($scope, '/api/purchaseorder/printpolist', report, 'PurchasOrderListingReport.pdf');
		}

		function exportToCSV(model) {
			var entries = [];
			var poItems = $filter('filter')(model.requisitions, model.applyFilter);
			poItems = $filter('orderBy')(poItems, model.filter.propertyName, model.filter.reverse);
			entries.push('Req#,Vendor,Site,DeliveryDate,Total,CheckRequest,Status,Delivered,Comments');
			angular.forEach(poItems, function (po) {
				var itemArray = [];
				itemArray.push(po.ReqNumber);
				itemArray.push('"' + po.OrderTo + '"');
				itemArray.push('"' + po.ShipTo + '"');
				itemArray.push(moment(po.DeliverDT).format('MM/DD/YYYY'));
				itemArray.push(po.Total);
				itemArray.push(po.CheckRequest);
				itemArray.push(po.Status);
				itemArray.push(po.Delivered);
				itemArray.push('"' + po.Memo + '"');
				entries.push(itemArray.join(','));
			});
			var file = entries.join('\n');
			var blob = new Blob([file], { type: 'text/csv' });
			saveAs(blob, 'reqlist.csv');
		}

		function sortby(model, propertyName) {
			model.filter.reverse = model.filter.propertyName === propertyName ? !model.filter.reverse : false;
			model.filter.propertyName = propertyName;
			model.busyMessage = BUSY_MESSAGE.Loading;
			$scope.busyPromise = model.loadRequisitions();
		}

		function getApprovalUsers() {
			return purchaseOrderService.getApprovalUsers().then(finishApprovalUsers);

			function finishApprovalUsers(response) {
				const approvalUsers = response.data.map(function (item) {
					return {
						userName: item.UserName.toUpperCase(),
					};
				});

				const curUserName = authService.authentication.userName.toUpperCase();
				const found = approvalUsers.find((user) => user.userName === curUserName);

				if (found) {
					$scope.vm.canApprove = true;
				}
			}
		}

		function approveSelected(model) {
			var selectedPO = _.filter($filter('filter')(model.requisitions, model.applyFilter), function (po) {
				return po.Selected === true;
			});

			const confirmFunc = function () {
				const reqs = selectedPO.map(function (r) {
					return r.Id;
				});

				$scope.busyPromise = purchaseOrderService.approveRequisitions(reqs, null).then(finishApproveRequisition);

				function finishApproveRequisition(response) {
					if (response.data.errors) {
						dialogHelper.openMessageBox('Error: Invalid approver!', response.data.errors, null, 'Warning');
						return;
					}

					if (response.data.createdPONumbers) {
						if (response.data.createdPONumbers.length > 0) {
							var poMessage = [];
							for (var i = 0; i < response.data.createdPONumbers.length; i++) {
								const poNum = response.data.createdPONumbers[i];
								poMessage.push(`PO # ${poNum} has been created.`);
							}
							dialogHelper.openMessageBox('Purchase Order(s) Created!', null, poMessage, 'Info');
						}
					}

					model.busyMessage = BUSY_MESSAGE.Loading;
					$scope.busyPromise = model.loadRequisitions();
				}
			};

			const params = {
				mainText: 'Approve selected requisitions?',
				detailText: `${selectedPO.length} requisitions will be approved.\xa0\xa0\xa0\xa0\xa0\xa0\xa0  Are you sure?`,
				iconType: 'Question',
				acceptButton: {
					text: 'YES',
					func: confirmFunc,
				},
			};

			return dialogHelper.actionDialog(params);
		}

		return angular.extend(model, {
			loadRequisitions: _.partial(loadRequisitions, model),
			changePage: _.partial(changePage, model),
			newEditRequisition: _.partial(newEditRequisition, model),
			loadSitePOSetup: _.partial(loadSitePOSetup, model),
			loadPurchaseOrderStatus: _.partial(loadPurchaseOrderStatus, model),
			applyFilter: _.partial(applyFilter, model),
			searchTextChanged: _.partial(searchTextChanged, model),
			search: _.partial(search, model),
			selectAll: _.partial(selectAll, model),
			isAllSelected: _.partial(isAllSelected, model),
			selectedCount: _.partial(selectedCount, model),
			hasListItems: _.partial(hasListItems, model),
			closeOrDeleteReq: _.partial(closeOrDeleteReq, model),
			closeOrDeleteReqs: _.partial(closeOrDeleteReqs, model),
			printReqList: _.partial(printReqList, model),
			exportToCSV: _.partial(exportToCSV, model),
			sortby: _.partial(sortby, model),
			approveSelected: _.partial(approveSelected, model),
			getApprovalUsers: getApprovalUsers,
		});
	}
}
